import styled from 'styled-components';
import { FormContainer } from './ExtrasOnlyBooking.styles';

export const PassengerSection = styled(FormContainer)`
  margin-bottom: 20px;
  position: relative;
`;

export const PassengerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const PassengerName = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
`;

export const JourneyHeading = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 12px 0;
`;
